<div class="flex flex-col space-y-4">
  <p-panel header="Description" [toggleable]="true">
    <ng-template pTemplate="headericons" let-collapsed>
      @if (collapsed) {
        <i class="pi pi-arrow-up-right-and-arrow-down-left-from-center"></i>
      } @else {
        <i class="pi pi-arrow-down-left-and-arrow-up-right-to-center"></i>
      }
    </ng-template>
    <textarea
      pTextarea
      fluid
      [minRows]="10"
      autosize
      [formControl]="shot.controls.description"
      [style]="{ resize: 'none' }"
      placeholder="Start typing text..."></textarea>
  </p-panel>
  <p-panel
    header="Natural Language Prompt"
    [collapsed]="true"
    [toggleable]="true">
    <ng-template pTemplate="headericons" let-collapsed>
      @if (collapsed) {
        <i class="pi pi-arrow-up-right-and-arrow-down-left-from-center"></i>
      } @else {
        <i class="pi pi-arrow-down-left-and-arrow-up-right-to-center"></i>
      }
    </ng-template>
    <textarea
      pTextarea
      fluid
      [minRows]="10"
      autosize
      [formControl]="shot.controls.naturalLanguagePrompt"
      [style]="{ resize: 'none' }"
      placeholder="Start typing text..."></textarea>
  </p-panel>
  <p-panel header="JSON Prompt" [collapsed]="!jsonPrompt" [toggleable]="true">
    <ng-template pTemplate="headericons" let-collapsed>
      @if (collapsed) {
        <i class="pi pi-arrow-up-right-and-arrow-down-left-from-center"></i>
      } @else {
        <i class="pi pi-arrow-down-left-and-arrow-up-right-to-center"></i>
      }
    </ng-template>
    <ng-template pTemplate="icons">
      @if (jsonPrompt) {
        <p-button
          text
          rounded
          icon="pi pi-undo"
          severity="warn"
          aria-label="Reset Json Prompt"
          (onClick)="onResetJsonPromptClick()" />
        <p-button
          text
          rounded
          icon="pi pi-trash"
          severity="danger"
          aria-label="Delete Json Prompt"
          (onClick)="onDeleteJsonPromptClick()" />
      } @else {
        <p-button
          text
          rounded
          icon="pi pi-plus"
          aria-label="Create Json Prompt"
          (onClick)="onCreateJsonPromptClick()" />
      }
    </ng-template>
    @if (jsonPrompt) {
      <app-json-editor [(value)]="jsonPrompt" [schema]="jsonPromptSchema" />
    }
  </p-panel>
</div>
